/**
 * MSAL Configuration
 * Best Practice: Centralize all MSAL auth configuration
 */
import { Configuration, RedirectRequest } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_FRONTEND_URL || window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_FRONTEND_URL || window.location.origin,
    navigateToLoginRequestUrl: true, // Allow navigation for redirect flow
  },
  cache: {
    cacheLocation: 'localStorage', // Use localStorage to persist auth across tabs
    storeAuthStateInCookie: false, // Set to true only if you support IE11
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 0: // Error
            console.error(message);
            break;
          case 1: // Warning
            console.warn(message);
            break;
          default:
            // Skip info and verbose logging
            break;
        }
      },
      logLevel: 1, // Only log errors and warnings
    },
    // Configuration for redirect-based authentication
    iframeHashTimeout: 6000, // Standard timeout
    loadFrameTimeout: 0, // Standard frame timeout
  },
};

// Add scopes for ID token to be used at Microsoft login
export const loginRequest: RedirectRequest = {
  scopes: ['https://graph.microsoft.com/.default'],
  prompt: 'select_account', // Add prompt to avoid cached account issues
};

// Add scopes for API access token - Use your API's client ID
export const apiRequest: RedirectRequest = {
  scopes: [`api://${process.env.REACT_APP_AZURE_CLIENT_ID}/access_as_user`],
};